"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDashboardToolbarButton = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var ALIGN_POINTS = [{ align: "tc bc", offset: { x: 0, y: -5 } }];
var DashboardToolbarButtonBubbleWrapper = function (props) {
    var tooltip = props.tooltip, children = props.children;
    if (!tooltip) {
        return react_1.default.createElement("div", { className: "gd-toolbar-button-wrapper" }, children);
    }
    return (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { className: "gd-toolbar-button-wrapper" },
        children,
        react_1.default.createElement(sdk_ui_kit_1.Bubble, { alignPoints: ALIGN_POINTS }, tooltip)));
};
/**
 * @internal
 */
exports.DefaultDashboardToolbarButton = function (props) {
    var _a;
    var tooltip = props.tooltip, disabled = props.disabled, icon = props.icon, onClick = props.onClick, isActive = props.isActive;
    return (react_1.default.createElement(DashboardToolbarButtonBubbleWrapper, { tooltip: tooltip },
        react_1.default.createElement(sdk_ui_kit_1.Button, { className: classnames_1.default("gd-button-secondary", (_a = {}, _a["gd-icon-" + icon] = icon, _a["is-active"] = isActive, _a)), disabled: disabled, onClick: onClick })));
};
//# sourceMappingURL=DefaultDashboardToolbarButton.js.map